// extracted by mini-css-extract-plugin
module.exports = {"footerMenu__title":"c3_rc","footerMenu__items":"c3_rd","footerMenu__item":"c3_rf","footerMenu__icon":"c3_rg","footerMenu__links":"c3_rh","footerMenu__link":"c3_rj"};